import React, { useEffect, useState } from 'react';
import Notification from '../../../../../interfaces/Notification';
import MenuItem from './MenuItem';
import DropDown from './DropDown';
import { createUseStyles } from 'react-jss';
import { itemsPerPage } from '../../../../../data/params';
import { BiEnvelope as MessageIcon } from '@react-icons/all-files/bi/BiEnvelope';
import NotifButton from './NotifButton';
import useAuth from '../../../../../hooks/api/useAuth';

const apiNotificationShow = '/api/notifications/show/';
const apiNotificationAllSeen = '/api/notifications/markAllSeen/';
const apiNotifications = '/api/notifications/employeeNotification/';

const linkTo = {
  contact: '/dashboard/contact/',
  customer: '/dashboard/customer/',
  deal: '/dashboard/deal/',
  ticket: '/dashboard/ticket/',
  task: '/dashboard/task/',
  appointment: '/dashboard/appointment/',
  reminder: '/dashboard/reminder/',
  wall: '/dashboard/wall/',
  post: '/dashboard/post/',
};

const useStyles = createUseStyles({
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    fill: '#3f4d67',
    '&:hover': {
      fill: '#0e141d',
    },
  },
});

const MessageDropDown = ({ navigateTo, className }) => {
  const classes = useStyles();
  const { fetch } = useAuth();
  const { notifications, newNotificationTotal, markSeenAllNotif, markSeenNotif, refresh, loading } = useNotifications(
    fetch
  );

  useEffect(() => {
    const intervalcheckForNotif = setInterval(refresh, 60000);
    return clearTimeout(intervalcheckForNotif);
  }, [refresh]);

  const getAppropriateLink = (type, id) => {
    let link;
    if (type && id && linkTo[type]) {
      link = linkTo[type] ? linkTo[type] + id : '/dashboard/';
    } else {
      link = undefined;
    }

    return link;
  };

  const handleClickOnNotif = (notification: Notification) => {
    if (!notification.beenSeen) {
      markSeenNotif(notification.id);
    }

    const link = getAppropriateLink(notification.linkType, notification.linkId);
    if (link) {
      navigateTo(link);
    }
  };

  return (
    <DropDown
      className={className}
      title='Messages'
      emptyText='Aucun message'
      onMarkAllSeen={markSeenAllNotif}
      buttonComponent={(props) => (
        <NotifButton
          icon={MessageIcon}
          notificationCount={newNotificationTotal}
          className={classes.icon}
          size={20}
          {...props}
        />
      )}
      renderDropDownItem={(item, key) => (
        <MenuItem onClick={() => handleClickOnNotif(item)} notification={item} key={key} />
      )}
      list={notifications}
      loading={loading}
    />
  );
};

const useNotifications = (authFetch, offset = 0) => {
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState<Array<Notification>>([]);
  const [newNotificationTotal, setNewNotificationTotal] = useState(0);

  const sortNotifications = (a: any, b: any) => {
    if (a.beenSeen == b.beenSeen) {
      return new Date(b.triggerDate).getTime() - new Date(a.triggerDate).getTime();
    }

    return a.beenSeen ? 1 : -1;
  };

  const markSeenNotif = (id) => {
    let queryURL = apiNotificationShow;
    const graphQL = 'mutation{ notification(id:' + id + ', beenSeen:true ){ id, title, beenSeen }  }';
    queryURL += graphQL;

    authFetch(queryURL, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['notification'] && data['data']['notification']['beenSeen']) {
          // update went fine
          checkForNotif();
        } else {
          console.log('notif not updated');
        }
      })
      .catch((error) => {
        console.log('erreur fetch mark as seen notif: \n' + error);
      });
  };

  const markSeenAllNotif = () => {
    const queryURL = apiNotificationAllSeen + 'message';

    authFetch(queryURL, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['isValid']) {
          // update went fine
          checkForNotif();
        } else {
          console.log('notif not updated');
        }
      })
      .catch((error) => {
        console.log('erreur fetch mark all seen notif: \n' + error);
      });
  };

  const checkForNotif = () => {
    setLoading(true);

    let queryURL = apiNotifications;
    const graphQL =
      '{ messageNotifications( offset:' +
      itemsPerPage['navbar_notification'] * offset +
      ', limit:' +
      itemsPerPage['navbar_notification'] +
      '){ exNotifications{ id, title, triggerDate, linkType, linkId, beenSeen }, newNotifications{ id, title, triggerDate, linkType, linkId, beenSeen }} }';
    queryURL += graphQL;

    authFetch(queryURL, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    })
      .then((resp) => resp.json())
      .then((data) => {
        let messageNotifications = data['data']['messageNotifications'];

        if (messageNotifications) {
          setLoading(false);

          setNewNotificationTotal(messageNotifications['newNotifications'].length);

          messageNotifications = messageNotifications['newNotifications'].concat(
            messageNotifications['exNotifications']
          );
          setNotifications(messageNotifications.sort(sortNotifications));
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log('erreur fetch notif list: \n' + error);
      });
  };

  useEffect(() => {
    checkForNotif();
  }, [offset]);

  return {
    notifications,
    newNotificationTotal,
    markSeenNotif,
    markSeenAllNotif,
    refresh: checkForNotif,
    loading,
  };
};

export default MessageDropDown;
